import { useEffect, useState } from 'react';
import { Maximize, Minimize } from 'lucide-react';

type FsDoc = Document & {
  webkitFullscreenElement?: Element | null;
  webkitExitFullscreen?: () => Promise<void>;
};
type FsEl = HTMLElement & {
  webkitRequestFullscreen?: () => Promise<void>;
};

export default function FullscreenToggle() {
  const [isFs, setIsFs] = useState(false);

  useEffect(() => {
    const doc = document as FsDoc;
    const onChange = () =>
      setIsFs(Boolean(doc.fullscreenElement || doc.webkitFullscreenElement));
    document.addEventListener('fullscreenchange', onChange);
    document.addEventListener('webkitfullscreenchange', onChange);
    onChange();
    return () => {
      document.removeEventListener('fullscreenchange', onChange);
      document.removeEventListener('webkitfullscreenchange', onChange);
    };
  }, []);

  const toggle = async () => {
    const doc = document as FsDoc;
    const el = document.documentElement as FsEl;
    try {
      if (!doc.fullscreenElement && !doc.webkitFullscreenElement) {
        if (el.requestFullscreen) await el.requestFullscreen();
        else if (el.webkitRequestFullscreen) await el.webkitRequestFullscreen();
      } else {
        if (doc.exitFullscreen) await doc.exitFullscreen();
        else if (doc.webkitExitFullscreen) await doc.webkitExitFullscreen();
      }
    } catch (err) {
      console.warn('Fullscreen not allowed:', err);
    }
  };

  return (
    <button
      type="button"
      onClick={toggle}
      title={isFs ? 'Exit full screen' : 'Full screen'}
      className="flex h-8 w-8 items-center justify-center rounded-lg text-content-muted hover:bg-surface-card-hover hover:text-content-primary transition-colors"
    >
      {isFs ? <Minimize size={18} /> : <Maximize size={18} />}
    </button>
  );
}
